import React, { useEffect, useState } from 'react';
import Toast from './Toast';
import useUIStore from '../../stores/uiStore';

const ToastContainer: React.FC = () => {
  const { toasts, hideToast } = useUIStore();
  const [previousToastCount, setPreviousToastCount] = useState(0);

  useEffect(() => {
    // When toast count decreases, trigger slide-up animation
    if (toasts.length < previousToastCount) {
      // The flex layout will handle the slide-up automatically
      // We just need to ensure smooth transition
    }
    setPreviousToastCount(toasts.length);
  }, [toasts.length, previousToastCount]);

  return (
    <div 
      style={{ 
        position: 'fixed',
        top: '16px',
        right: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        maxWidth: '320px',
        zIndex: 99999,
        pointerEvents: 'none',
        transition: 'all 0.3s ease-in-out'
      }}
    >
      {toasts.map((toast) => (
        <div 
          key={toast.id} 
          style={{ 
            pointerEvents: 'auto',
            transition: 'all 0.3s ease-in-out',
            transform: toast.isLeaving ? 'translateX(100%)' : 'translateX(0)',
            opacity: toast.isLeaving ? 0 : 1
          }}
        >
          <Toast
            id={toast.id}
            type={toast.type}
            message={toast.message}
            duration={toast.duration || 3000}
            isLeaving={toast.isLeaving || false}
            onClose={hideToast}
            position="top-right"
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
